import { useEffect } from 'react';
import { useWebSocket } from './useWebSocket';
import { useAuthStore } from '../store/useAuthStore';
import type { UserRole } from '../types/auth';

/**
 * useAuthSync — listens for real-time auth changes (role updates).
 * Call once from AppShell so it's active for all authenticated users.
 */
export const useAuthSync = () => {
  const { token } = useAuthStore();
  const websocket = useWebSocket({ autoConnect: !!token });

  useEffect(() => {
    if (!websocket.isConnected) return;

    const handleRoleChanged = (payload: { role: UserRole }) => {
      const { setAuth, token: currentToken, user } = useAuthStore.getState();
      if (currentToken && user) {
        setAuth({ token: currentToken, user: { ...user, role: payload.role } });
      }
      // Reload so menus, routes, and guards reflect the new role
      window.location.reload();
    };

    websocket.on('auth:role-changed', handleRoleChanged);

    return () => {
      websocket.off('auth:role-changed', handleRoleChanged);
    };
  }, [websocket.isConnected, websocket]);
};
